<template>
<q-page class="main">
  <q-card class="page-card">
    <q-card-section class="page-card__main-content">
      <item-header :item="object">
        <template v-slot:header>
          <h1 class="heading-2 q-mb-lg">{{ object.title }}</h1>
        </template>
      </item-header>

      <object-info :item="object" />
    </q-card-section>
    <q-card-section class="page-card__details">
      <expansion-element
          label="Documenten"
          :items-count="object.assets.length"
          showEmpty>
        <document-list
            :documents="object.assets"
        />
      </expansion-element>
      <expansion-element
          label="Categorieën"
          :items-count="categoriesCount"
      >
        <chip-list :items="object.categories" />
      </expansion-element>
    </q-card-section>
  </q-card>
  <sticky-top-bar />
  <sticky-bottom-bar v-if="$can('updateObjects', project)">
    <common-fab label="Bewerken" icon="edit"
                @click="$goto('project.object.edit', {project_id: project.id})" />
  </sticky-bottom-bar>
</q-page>
</template>

<script>
import ChipList from "~HIOR/components/lists/ChipList"
import ObjectInfo from "./../../object/ObjectInfo"
import DocumentList from '~HIOR/components/lists/DocumentList'

export default {
  components: {
    ChipList,
    ObjectInfo,
    DocumentList
  },
  props: {
    project: {
      type: Object,
      default: null,
    },
    object: {
      type: Object,
      default: null,
    },
  },
  computed: {
    categoriesCount () {
      return this.object.categories ? this.object.categories.length : null
    },
  },
}
</script>
